import { Component } from '@angular/core'
import { ProfileLinkComponent } from './components/profile-link/profile-link.component'
import { HelpLinkComponent } from './components/help-link/help-link.component'
import { ReferLinkComponent } from './components/refer-link/refer-link.component'
import { SettingsLinkComponent } from './components/settings-link/settings-link.component'
import { PeopleLinkComponent } from './components/people-link/people-link.component'
import { LogoLinkComponent } from './components/logo-link/logo-link.component'
import { TooltipModule } from 'primeng/tooltip'
import { HomeLinkComponent } from './components/home-link/home-link.component'
import { MenuLinkComponent } from './components/menu-link/menu-link.component'
import { ToggleButtonModule } from 'primeng/togglebutton'
import { FormsModule } from '@angular/forms'
import { UserService } from '@app/core/_services/user.service'
import { Subject, takeUntil } from 'rxjs'
import { User } from '@app/core/_models'
import { LocalStorageAccessService } from '@app/core/_services/local-storage-access.service'
import { LayoutService } from '@app/core/_services/layout.service'

@Component({
    selector: 'fm-navigation',
    imports: [
        FormsModule,
        ToggleButtonModule,
        MenuLinkComponent,
        HomeLinkComponent,
        TooltipModule,
        LogoLinkComponent,
        ProfileLinkComponent,
        PeopleLinkComponent,
        HelpLinkComponent,
        ReferLinkComponent,
        SettingsLinkComponent,
    ],
    templateUrl: './navigation.component.html',
    styleUrl: './navigation.component.scss',
})
export class NavigationComponent {
    private ngUnsubscribe: Subject<any> = new Subject<any>()

    constructor(
        private layoutService: LayoutService,
        private localStorageAccessService: LocalStorageAccessService,
        private userService: UserService,
    ) {}

    ngOnInit() {
        this.userService.currentUser.pipe(takeUntil(this.ngUnsubscribe)).subscribe((user: User) => {
            if (
                user.userId &&
                !user.features.accessNewLayout &&
                this.localStorageAccessService.getItem('newLayout') === 't'
            ) {
                // Unlikely scenario of someone that does not have beta access but somehow
                // has 'newLayou' set in their localStorage. If this happens, revert to old layout
                this.layoutService.toggleLayout()
            }
        })
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null)
        this.ngUnsubscribe.complete()
    }
}
